<template>
    <moe-page>
        <moe-top></moe-top>
        <div class="container">
            <div class="main-content">
                <div class="categories">
                    <div class="category_class">常见问题分类</div>
                    <ul class="category-list">
                        <li v-for="category in categories" :key="category.id" class="category-item">
                            <div class="category-header" :class="{ active: currentCategory === category.id }"
                                @click="toggleCategory(category.id)">
                                <span>{{ category.name }}</span>
                                <i class="fas"
                                    :class="isCategoryOpen(category.id) ? 'fa-chevron-down' : 'fa-chevron-right'"></i>
                            </div>
                            <div class="question-submenu" :class="{ open: isCategoryOpen(category.id) }">
                                <div v-for="question in getQuestionsByCategory(category.id)" :key="question.id"
                                    :class="['submenu-item', { active: selectedQuestion && selectedQuestion.id === question.id }]"
                                    @click="selectQuestion(question)">
                                    {{ question.title }}
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="faq-content">
                    <div class="breadcrumb">
                        <a href="#" @click.prevent="goHome">帮助中心</a> >
                        <a href="#" @click.prevent="selectCategory(currentCategory)">{{ getCategoryName(currentCategory)
                            }}</a> >
                        <span>{{ selectedQuestion ? selectedQuestion.title : '选择问题' }}</span>
                    </div>

                    <div class="answer-content" v-if="selectedQuestion">
                        <h3>{{ selectedQuestion.questionName }}</h3>
                        <div v-html="selectedQuestion.answer"></div>
                    </div>

                    <div class="no-result" v-else-if="searchQuery && filteredQuestions.length === 0">
                        <i class="fas fa-search fa-2x" style="margin-bottom: 15px;"></i>
                        <p>没有找到与 "{{ searchQuery }}" 相关的问题</p>
                    </div>

                    <div class="no-result" v-else-if="!selectedQuestion">
                        <i class="fas fa-question-circle fa-2x" style="margin-bottom: 15px;"></i>
                        <p>请从左侧选择一个分类和问题</p>
                    </div>
                </div>
            </div>
        </div>

        <moe-bottom></moe-bottom>
    </moe-page>
</template>

<script>
export default {
    name: 'HelpCenter',
    data() {
        return {
            categories: [],
            questions: [],
            currentCategory: '',
            selectedQuestion: null,
            searchQuery: '',
            openCategories: [''] // 默认展开账户问题分类
        }
    },
    computed: {
        filteredQuestions() {
            if (this.searchQuery) {
                return this.questions.filter(q =>
                    q.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    q.answer.toLowerCase().includes(this.searchQuery.toLowerCase())
                )
            }
            return this.questions.filter(q => q.category === this.currentCategory)
        }
    },
    mounted() {
        this.getHelpCategory();
    },
    methods: {
        // 常见问题分类
        getHelpCategory() {
            this.$Api.common.getDictList({ dictName: 'helpCategory' }).then(res => {
                this.categories = res.data.data.map(item => {
                    return { name: item.dictName, id: item.dictId }
                });
                this.getNormalQuestionList();
            }).catch(() => { })
        },
        getNormalQuestionList() {
            this.$Api.common.getNormalQuestionList({ scene: 1 }).then(res => {
                this.questions = res.data.data.list.map(item => {
                    return { id: item.id, category: item.categoryName, title: item.subcategoryName, answer: item.content,questionName:item.questionName,dictId:item.categoryName }
                })

                this.categories.forEach((item,index) => {
                    let findIndex = this.questions.findIndex(sitem => sitem.dictId == item.id);
                    if(findIndex == -1){
                        this.categories.splice(index,1);
                    }
                })
                console.log(this.categories)
                // 默认选择第一个问题
                if (this.questions.length > 0) {
                    this.selectedQuestion = this.questions[0] // 选择"账户注销"问题
                    this.openCategories[0] = this.categories[0].id; 
                    this.currentCategory = this.categories[0].id; 
                }
            }).catch(() => { })
        },
        toggleCategory(categoryId) {
            // 清除搜索状态
            this.searchQuery = ''

            // 如果点击的是当前已展开的分类，则关闭它
            if (this.isCategoryOpen(categoryId) && this.openCategories.length === 1) {
                this.openCategories = []
                // this.currentCategory = ''
                // this.selectedQuestion = null
                return
            }

            // 否则，关闭其他分类，只展开当前分类
            this.closeOtherCategories(categoryId)
            this.currentCategory = categoryId

            // 如果当前分类有问题，自动选择第一个问题
            const categoryQuestions = this.getQuestionsByCategory(categoryId)
            if (categoryQuestions.length > 0) {
                this.selectedQuestion = categoryQuestions[0]
            }
        },

        // 关闭除指定分类外的所有分类
        closeOtherCategories(categoryId) {
            this.openCategories = [categoryId]
        },

        isCategoryOpen(categoryId) {
            return this.openCategories.includes(categoryId)
        },

        getQuestionsByCategory(categoryId) {
            if (this.searchQuery) {
                return this.filteredQuestions.filter(q => q.category === categoryId)
            }
            return this.questions.filter(q => q.category === categoryId)
        },

        selectQuestion(question) {
            this.selectedQuestion = question
            this.currentCategory = question.category

            // 确保该分类是展开状态
            if (!this.isCategoryOpen(question.category)) {
                this.closeOtherCategories(question.category)
            }

            // 清除搜索状态
            this.searchQuery = ''
        },

        selectCategory(categoryId) {
            console.log(categoryId);
            return
            // this.currentCategory = categoryId
            // this.selectedQuestion = null
            // this.searchQuery = ''

            // // 确保该分类是展开状态
            // if (!this.isCategoryOpen(categoryId)) {
            //     this.closeOtherCategories(categoryId)
            // }
        },

        goHome() {
            return
            // this.currentCategory = ''
            // this.selectedQuestion = null
            // this.searchQuery = ''
            // this.openCategories = ['']
        },

        getCategoryName(categoryId) {
            const category = this.categories.find(c => c.id === categoryId)
            return category ? category.name : '未知分类'
        },

        searchQuestions() {
            if (this.searchQuery) {
                this.currentCategory = ''
                // 搜索时展开所有分类
                this.openCategories = this.categories.map(c => c.id)
            } else {
                // 清除搜索时，回到默认状态
                this.openCategories = ['account']
                this.currentCategory = 'account'
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.container {
    background: #F3F3F3;
    width: 100%;
    min-height: 650px;
}

.main-content {
    display: flex;
    margin: 30px auto;
    gap: 20px;
    width: $pageMainWidth;
}

.categories {
    flex: 0 0 280px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    // padding: 20px;
    max-height: 800px;
    overflow-y: auto;

    .category_class {
        font-weight: 600;
        font-size: 16px;
        color: #303030;
        padding: 20px 20px 0;
    }
}

.categories h2 {
    color: #13D6AA;
    margin-bottom: 20px;
    padding-bottom: 10px;
    border-bottom: 2px solid #f0f0f0;
}

ul {
    padding-inline-start: 0;
}

.category-list {
    list-style: none;
}

.category-item {
    margin-bottom: 10px;
    border-radius: 6px;
    overflow: hidden;
}

.category-header {
    padding: 12px 30px;
    // background: #f8f9fa;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    transition: all 0.3s;
}

.category-header:hover {
    // background: #e9ecef;
}

.category-header.active {
    // background: #13D6AA;
    // color: white;
}

.question-submenu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease-out;
    // background: #f8f9fa;
}

.question-submenu.open {
    max-height: 500px;
}

.submenu-item {
    padding: 10px 15px 10px 50px;
    // height: 40px;
    line-height: 40px;
    cursor: pointer;
    // border-bottom: 1px solid #e9ecef;
    transition: all 0.2s;
    color: #909090;
}

.submenu-item:hover {
    // background: #e9ecef;
}

.submenu-item.active {
    // background: #e3f2fd;
    // color: #13D6AA;
    font-weight: 500;
    background: #F5FFFB;
    color: #13D6AA;
    border-left: 2px solid #13D6AA;
    box-sizing: border-box;
}

.faq-content {
    flex: 1;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    padding: 25px;
}

.breadcrumb {
    color: #7f8c8d;
    font-size: 14px;
    // margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.breadcrumb a {
    color: #13D6AA;
    text-decoration: none;
}

.breadcrumb a:hover {
    text-decoration: underline;
}

.answer-content {
    // background: #f9f9f9;
    padding: 20px;
    border-radius: 8px;
    // margin-top: 20px;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.answer-content h3 {
    color: #2c3e50;
    font-size: 20px;
    margin: 0;
    margin-bottom: 10px;
}

.answer-content p {
    margin-bottom: 15px;
    line-height: 1.8;
}

.answer-content ul,
.answer-content ol {
    margin: 15px 0;
    padding-left: 30px;
}

.answer-content li {
    margin-bottom: 10px;
}

.note {
    background: #fff9e6;
    border-left: 4px solid #f1c40f;
    padding: 15px;
    margin: 20px 0;
    border-radius: 0 4px 4px 0;
}

footer {
    text-align: center;
    margin-top: 40px;
    padding: 20px;
    color: #7f8c8d;
    font-size: 14px;
}

.no-result {
    text-align: center;
    padding: 40px;
    color: #7f8c8d;
}

@media (max-width: 768px) {
    .main-content {
        flex-direction: column;
    }

    .categories {
        flex: 1;
        width: 100%;
        max-height: none;
    }

    .search-box {
        width: 100%;
        margin-top: 15px;
    }

    .header-content {
        flex-direction: column;
    }
}
</style>